import { useWorkspace, WORKSPACE_FUNDS, WORKSPACE_TRADE, WORKSPACE_GENERAL } from '../context/WorkspaceContext.jsx';
import { t } from '../i18n/index.jsx';

/**
 * Segmented control across the three business lines: Italy Funds,
 * Morocco Trade, and General (internal initiatives — company setups,
 * label applications…). Lives in the topbar (desktop center / mobile compact).
 */
export default function WorkspaceSwitch() {
  const { workspace, switchWorkspace } = useWorkspace();

  return (
    <div className="workspace-switch" role="group" aria-label={t('Workspace')}>
      <button
        type="button"
        className={`workspace-opt ${workspace === WORKSPACE_FUNDS ? 'on' : ''}`}
        onClick={() => switchWorkspace(WORKSPACE_FUNDS)}
        title={t('Italy — Funds')}
      >
        <span className="workspace-flag" aria-hidden>IT</span>
        <span className="workspace-label">{t('Funds')}</span>
      </button>
      <button
        type="button"
        className={`workspace-opt ${workspace === WORKSPACE_TRADE ? 'on' : ''}`}
        onClick={() => switchWorkspace(WORKSPACE_TRADE)}
        title={t('Morocco — Trade')}
      >
        <span className="workspace-flag" aria-hidden>MA</span>
        <span className="workspace-label">{t('Trade')}</span>
      </button>
      <button
        type="button"
        className={`workspace-opt ${workspace === WORKSPACE_GENERAL ? 'on' : ''}`}
        onClick={() => switchWorkspace(WORKSPACE_GENERAL)}
        title={t('General — internal initiatives')}
      >
        <span className="workspace-flag" aria-hidden>★</span>
        <span className="workspace-label">{t('General')}</span>
      </button>
    </div>
  );
}
